import { ERROR_CODES as MFE_ERROR_CODES } from "diagnostics-domain/manualFaultEvent/error_types";
import type { ManualFaultEventErrorCode } from "diagnostics-domain/manualFaultEvent/error_types";

export const frValidations = {
  manualFaultEvents: (code: ManualFaultEventErrorCode | undefined): string | undefined => {
    if (!code) {
      return undefined;
    }

    switch (code) {
      case MFE_ERROR_CODES.NAME_EMPTY:
        return "Le nom de l'événement ne peut pas être vide";
      case MFE_ERROR_CODES.NAME_ALREADY_EXISTS:
        return "Un événement avec le même nom existe déjà";
      case MFE_ERROR_CODES.NAME_TOO_LONG:
        return "Le nom ne peut pas dépasser 100 caractères";
      case MFE_ERROR_CODES.START_DATE_EMPTY:
        return "La date de début est obligatoire";
      case MFE_ERROR_CODES.START_DATE_AFTER_SECOND_WINDOW:
        return "La date de début doit être située avant la date de début de la période suivante";
      case MFE_ERROR_CODES.START_DATE_AFTER_EVENT_END:
        return "La date de début doit être avant la date de clôture";
      case MFE_ERROR_CODES.START_DATE_NOT_IN_PROJECT_PERIOD:
        return "La date de début doit être située entre le premier et le dernier point de données lié à la source de données";
      case MFE_ERROR_CODES.CLOSE_DATE_EMPTY:
        return "La date de clôture est obligatoire";
      case MFE_ERROR_CODES.CLOSE_DATE_BEFORE_LAST_IMPACT_WINDOW:
        return "La date de clôture doit être après le début de la dernière fenêtre temporelle";
      case MFE_ERROR_CODES.CLOSE_DATE_NOT_IN_PROJECT_PERIOD:
        return "La date de clôture doit être située dans la période du projet";
      case MFE_ERROR_CODES.ACTION_TOO_LONG:
        return "Ce champ ne peut pas dépasser 4000 caractères";
      case MFE_ERROR_CODES.DESCRIPTION_TOO_LONG:
        return "La description ne peut pas dépasser 4000 caractères.";
      case MFE_ERROR_CODES.OVERLAPPING_EVENT_EXISTS:
        return "Un événement existant chevauche la période définie.";
      case MFE_ERROR_CODES.NO_ACTIVE_ANALYSIS:
        return "Au moins une analyse active est requise pour créer ou modifier un événement manuel";
      default:
        return "Une erreur inconnue est survenue";
    }
  },
};
